// extracted by mini-css-extract-plugin
export default {"slide":"testiSlide_slide__DlHvu","comment":"testiSlide_comment__PFzK6","name":"testiSlide_name__Xry80","title":"testiSlide_title__Hwcjm"};